// AddProduct.js - Updated with gallery image upload (like AddDesign)
import "./AddProduct.css"
import { useRef, useEffect, useState } from "react";
import { UilCalculator, UilProcess, UilTrashAlt } from "@iconscout/react-unicons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from "react-redux";
import ColorPreviewCanvas from "../../Components/ColorPreviewImage/ColorPreviewCanvas";

// â”€â”€â”€ Axios instance (no interceptor) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:4000/api",
  timeout: 60000,
});

// â”€â”€â”€ Storage keys for form persistence â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const FORM_STORAGE_KEY = "add_product_form_data";
const FORM_TIMESTAMP_KEY = "add_product_form_timestamp";

// Helper functions for form persistence (without images)
const saveFormToLocalStorage = (data) => {
  try {
    const dataToSave = {
      formData: data.formData,
      selectedSizeTypes: data.selectedSizeTypes,
      selectedSizes: data.selectedSizes,
      newColor: data.newColor,
      tagInput: data.tagInput,
      displayedColor: data.displayedColor,
      packValues: data.packValues,
    };
    localStorage.setItem(FORM_STORAGE_KEY, JSON.stringify(dataToSave));
    localStorage.setItem(FORM_TIMESTAMP_KEY, Date.now().toString());
    console.log("Form saved to localStorage (without images)");
  } catch (error) {
    console.error("Error saving form to localStorage:", error);
  }
};

const loadFormFromLocalStorage = () => {
  try {
    const savedData = localStorage.getItem(FORM_STORAGE_KEY);
    const timestamp = localStorage.getItem(FORM_TIMESTAMP_KEY);
    if (savedData && timestamp) {
      const parsedData = JSON.parse(savedData);
      const savedTime = parseInt(timestamp);
      const currentTime = Date.now();
      const hoursSinceSave = (currentTime - savedTime) / (1000 * 60 * 60);
      if (hoursSinceSave < 24) return parsedData;
    }
    return null;
  } catch (error) {
    console.error("Error loading form from localStorage:", error);
    return null;
  }
};

const clearFormFromLocalStorage = () => {
  localStorage.removeItem(FORM_STORAGE_KEY);
  localStorage.removeItem(FORM_TIMESTAMP_KEY);
  console.log("Form cleared from localStorage");
};

const slugifyProductIdPart = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const getDefaultFormData = () => ({
  _id: "",
  fournisseur: "",
  categoryId: "",
  category: "",
  subcategory: "",
  subcategoryId: "",
  title: "",
  purchase: 0,
  cost: 0,
  price: 0,
  discount: 0,
  description: "",
  tags: [],
  patronnage: "",
  fourniture: [],
  colorsAndSizes: {},
  sizesOnly: {},
  pack: [],
  rate: 5,
  isFinishedProduct: false,
  isPreorder: false,
  preorderAvailableAt: "",
  fabricRawMaterialId: "",
  fabricConsumption: {},
  isPublishedB2B: true,
  isPublishedAdmin: true,
});

export const AddProduct = () => {
  const [formData, setFormData] = useState(getDefaultFormData());
  const [rawMaterials, setRawMaterials] = useState([]);
  const [adultSizes] = useState(["XS", "S", "M", "L", "XL", "XXL"]);
  const [childSizes] = useState(["4", "6", "8", "10", "12", "14", "16"]);
  const [selectedSizeTypes, setSelectedSizeTypes] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [newColor, setNewColor] = useState("");
  const [tagInput, setTagInput] = useState("");
  const [fournitureInput, setFournitureInput] = useState("");
  const [displayedColor, setDisplayedColor] = useState("");
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);

  // Image handling (single front/back + gallery)
  const [frontImageFile, setFrontImageFile] = useState(null);
  const [backImageFile, setBackImageFile] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]); // array of { file, previewUrl, name, size }
  const [imagePreviews, setImagePreviews] = useState({ front: null, back: null });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [packValues, setPackValues] = useState({});
  const [showRestorePrompt, setShowRestorePrompt] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const frontCanvasRef = useRef(null);
  const backCanvasRef = useRef(null);
  const navigate = useNavigate();
  const { currentUser } = useSelector((state) => state.auth);

  // â”€â”€ Sync token to axios after Redux rehydration â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    const rawToken = currentUser?.token || null;
    const refreshToken = currentUser?.refreshToken || null;
    if (rawToken) {
      const token = rawToken.startsWith("Bearer ") ? rawToken : `Bearer ${rawToken}`;
      api.defaults.headers.common["Authorization"] = token;
      console.log(" Admin token synced to axios (AddProduct)");
    } else {
      delete api.defaults.headers.common["Authorization"];
      console.warn("No token in currentUser — admin may not be logged in");
    }
    if (refreshToken) {
      api.defaults.headers.common["x-refresh-token"] = refreshToken;
    } else {
      delete api.defaults.headers.common["x-refresh-token"];
    }
  }, [currentUser]);

  // â”€â”€ Save form data to localStorage whenever it changes (without images) â”€â”€â”€
  useEffect(() => {
    if (!isInitialLoad && hasUnsavedChanges) {
      const formStateToSave = {
        formData,
        selectedSizeTypes,
        selectedSizes,
        newColor,
        tagInput,
        displayedColor,
        packValues,
      };
      saveFormToLocalStorage(formStateToSave);
    }
  }, [formData, selectedSizeTypes, selectedSizes, newColor, tagInput, displayedColor, packValues, isInitialLoad, hasUnsavedChanges]);

  // â”€â”€ Mark that there are unsaved changes â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    if (!isInitialLoad) setHasUnsavedChanges(true);
  }, [formData, selectedSizeTypes, selectedSizes, newColor, tagInput, displayedColor, packValues]);

  // â”€â”€ Load saved form data on component mount â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    const checkForSavedForm = () => {
      const savedFormState = loadFormFromLocalStorage();
      if (savedFormState && savedFormState.formData) setShowRestorePrompt(true);
      setIsInitialLoad(false);
    };
    checkForSavedForm();
  }, []);

  // â”€â”€ Load categories â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await api.get("/categories");
        setCategories(response.data.categories);
      } catch (error) {
        console.error("Erreur de chargement des catégories", error);
      }
    };
    loadCategories();
  }, []);

  // â”€â”€ Load raw materials for the fabric-consumption picker (M9) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    const loadRawMaterials = async () => {
      try {
        const response = await api.get("/raw-materials/dropdown");
        setRawMaterials(response.data.rawMaterials || []);
      } catch (error) {
        console.error("Erreur de chargement des matières premières", error);
      }
    };
    loadRawMaterials();
  }, []);

  useEffect(() => {
    if (!formData.categoryId && !formData.category) {
      setSubcategories([]);
      return;
    }

    const category = categories.find(cat => String(cat._id) === String(formData.categoryId))
      || categories.find(cat => cat.title === formData.category);

    if (category && (!formData.categoryId || formData.category !== category.title)) {
      setFormData(prev => ({
        ...prev,
        categoryId: category._id,
        category: category.title,
      }));
    }

    if (!category?._id) {
      setSubcategories([]);
      return;
    }

    const loadSubcategories = async () => {
      try {
        const response = await api.get(`/subcategories?categoryId=${category._id}`);
        setSubcategories(response.data.subcategories || []);
      } catch (error) {
        console.error("Erreur de chargement des sous-catégories", error);
        setSubcategories([]);
      }
    };
    loadSubcategories();
  }, [formData.categoryId, formData.category, categories]);

  // â”€â”€ Clean up gallery preview URLs on unmount â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    return () => {
      galleryImages.forEach(img => URL.revokeObjectURL(img.previewUrl));
      if (imagePreviews.front) URL.revokeObjectURL(imagePreviews.front);
      if (imagePreviews.back) URL.revokeObjectURL(imagePreviews.back);
    };
  }, [galleryImages, imagePreviews]);

  // â”€â”€ Restore / clear saved form â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const restoreSavedForm = () => {
    const savedFormState = loadFormFromLocalStorage();
    if (savedFormState) {
      if (savedFormState.formData) {
        const savedCategoryId = savedFormState.formData.categoryId || "";
        const savedCategoryTitle = savedFormState.formData.category || "";
        const category = categories.find(cat => String(cat._id) === String(savedCategoryId))
          || categories.find(cat => cat.title === savedCategoryTitle);

        setFormData({
          ...getDefaultFormData(),
          ...savedFormState.formData,
          categoryId: category?._id || savedCategoryId,
          category: category?.title || savedCategoryTitle,
        });
      }
      if (savedFormState.selectedSizeTypes) setSelectedSizeTypes(savedFormState.selectedSizeTypes);
      if (savedFormState.selectedSizes) setSelectedSizes(savedFormState.selectedSizes);
      if (savedFormState.newColor) setNewColor(savedFormState.newColor);
      if (savedFormState.tagInput) setTagInput(savedFormState.tagInput);
      if (savedFormState.displayedColor) setDisplayedColor(savedFormState.displayedColor);
      if (savedFormState.packValues) setPackValues(savedFormState.packValues);
      toast.warning("Formulaire restauré. Veuillez re-télécharger les images.", { autoClose: 4000 });
    } else {
      toast.warning("Aucune donnée à restaurer", { autoClose: 2000 });
    }
    setShowRestorePrompt(false);
    setHasUnsavedChanges(false);
  };

  const clearSavedForm = () => {
    clearFormFromLocalStorage();
    setShowRestorePrompt(false);
    setHasUnsavedChanges(false);
    toast.info("Formulaire sauvegardé effacé", { autoClose: 2000 });
  };

  const resetForm = () => {
    setFormData(getDefaultFormData());
    setSelectedSizeTypes([]);
    setSelectedSizes([]);
    setNewColor("");
    setTagInput("");
    setDisplayedColor("");
    setPackValues({});
    setImagePreviews({ front: null, back: null });
    setFrontImageFile(null);
    setBackImageFile(null);
    setGalleryImages([]);
    clearFormFromLocalStorage();
    setHasUnsavedChanges(false);
    toast.success("Formulaire réinitialisé", { autoClose: 2000 });
  };

  // â”€â”€ Before unload warning â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges && !isInitialLoad) {
        e.preventDefault();
        e.returnValue = "Vous avez des modifications non sauvegardées. Voulez-vous vraiment quitter ?";
        return e.returnValue;
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges, isInitialLoad]);

  // â”€â”€ Utility functions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
  const getAllAvailableSizes = () => {
    const sizes = [];
    if (selectedSizeTypes.includes('adult')) sizes.push(...adultSizes.map(size => ({ type: 'adult', label: size, value: size })));
    if (selectedSizeTypes.includes('child')) sizes.push(...childSizes.map(size => ({ type: 'child', label: `${size} ans`, value: size })));
    return sizes;
  };

  const handleFinishedProductToggle = (isFinished) => {
    setFormData(prev => ({
      ...prev,
      isFinishedProduct: isFinished,
      colorsAndSizes: isFinished ? {} : prev.colorsAndSizes,
      sizesOnly: !isFinished ? {} : prev.sizesOnly,
    }));
  };

  useEffect(() => {
    if (selectedSizes.length > 0 && formData.pack.length !== selectedSizes.length) {
      const newPack = new Array(selectedSizes.length).fill(0);
      setFormData(prev => ({ ...prev, pack: newPack }));
    }
  }, [selectedSizes]);

  useEffect(() => {
    if (displayedColor) {
      if (frontCanvasRef?.current?.applyColor) frontCanvasRef.current.applyColor(displayedColor);
      if (backCanvasRef?.current?.applyColor) backCanvasRef.current.applyColor(displayedColor);
    }
  }, [displayedColor]);

  const handleSizeTypeToggle = (type) => {
    let newSelectedTypes;
    if (selectedSizeTypes.includes(type)) {
      newSelectedTypes = selectedSizeTypes.filter(t => t !== type);
    } else {
      newSelectedTypes = [...selectedSizeTypes, type];
    }
    setSelectedSizeTypes(newSelectedTypes);
    setFormData(prev => ({ ...prev, sizeTypes: newSelectedTypes }));
    const sizesToRemove = type === 'adult' ? adultSizes : childSizes;
    const remainingSizes = selectedSizes.filter(size => !sizesToRemove.includes(size));
    setSelectedSizes(remainingSizes);
    if (formData.isFinishedProduct) {
      const updatedSizesOnly = { ...formData.sizesOnly };
      sizesToRemove.forEach(size => delete updatedSizesOnly[size]);
      setFormData(prev => ({ ...prev, sizesOnly: updatedSizesOnly }));
    } else {
      const updatedColors = { ...formData.colorsAndSizes };
      Object.keys(updatedColors).forEach(color => {
        sizesToRemove.forEach(size => delete updatedColors[color][size]);
      });
      setFormData(prev => ({ ...prev, colorsAndSizes: updatedColors }));
    }
  };

  const handleImageUpload = (type, file) => {
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);
    setImagePreviews(prev => ({ ...prev, [type]: previewUrl }));
    if (type === 'front') setFrontImageFile(file);
    else setBackImageFile(file);
    toast.success(`Image ${type === 'front' ? 'devant' : 'dos'} chargée`, { autoClose: 2000 });
  };

  const handleGalleryImageUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    const newImages = files.map((file, idx) => ({
      id: `${Date.now()}_${idx}_${Math.random()}`,
      file,
      previewUrl: URL.createObjectURL(file),
      name: file.name,
      size: file.size,
    }));

    setGalleryImages(prev => [...prev, ...newImages]);
    setHasUnsavedChanges(true);
    toast.success(`${files.length} image(s) ajoutée(s) à la galerie`, { autoClose: 2000 });
    e.target.value = null;
  };

  const handleDeleteGalleryImage = (imageId) => {
    setGalleryImages(prev => {
      const imgToRemove = prev.find(img => img.id === imageId);
      if (imgToRemove) URL.revokeObjectURL(imgToRemove.previewUrl);
      return prev.filter(img => img.id !== imageId);
    });
    setHasUnsavedChanges(true);
    toast.success("Image supprimée", { autoClose: 1500 });
  };

  const handlePackChange = (index, value) => {
    const newPack = [...formData.pack];
    newPack[index] = Number(value);
    setFormData({ ...formData, pack: newPack });
  };

  const handleAddTag = () => {
    const trimmed = tagInput.trim();
    if (trimmed && !formData.tags?.includes(trimmed)) {
      setFormData({ ...formData, tags: [...formData.tags, trimmed] });
      setTagInput("");
    }
  };

  const handleAddFourniture = () => {
    const trimmed = fournitureInput.trim();
    if (trimmed && !formData.fourniture?.includes(trimmed)) {
      setFormData({ ...formData, fourniture: [...formData.fourniture, trimmed] });
      setFournitureInput("");
    }
  };

  const handleSizeChange = (sizeValue) => {
    const newSelectedSizes = selectedSizes.includes(sizeValue)
      ? selectedSizes.filter(s => s !== sizeValue)
      : [...selectedSizes, sizeValue];
    const sortedSizes = [...newSelectedSizes].sort((a, b) => {
      const aIsAdult = adultSizes.includes(a);
      const bIsAdult = adultSizes.includes(b);
      if (aIsAdult && !bIsAdult) return -1;
      if (!aIsAdult && bIsAdult) return 1;
      if (aIsAdult && bIsAdult) {
        const order = ["XS", "S", "M", "L", "XL", "XXL"];
        return order.indexOf(a) - order.indexOf(b);
      } else {
        return Number(a) - Number(b);
      }
    });
    setSelectedSizes(sortedSizes);
    if (formData.isFinishedProduct) {
      const updatedSizesOnly = { ...formData.sizesOnly };
      sortedSizes.forEach(size => { if (updatedSizesOnly[size] === undefined) updatedSizesOnly[size] = 0; });
      Object.keys(updatedSizesOnly).forEach(size => { if (!sortedSizes.includes(size)) delete updatedSizesOnly[size]; });
      setFormData(prev => ({ ...prev, sizesOnly: updatedSizesOnly }));
    } else {
      const updatedColors = { ...formData.colorsAndSizes };
      Object.keys(updatedColors).forEach(color => {
        const currentSizes = updatedColors[color];
        const newSizes = {};
        sortedSizes.forEach(newSize => {
          if (currentSizes && currentSizes[newSize] !== undefined) newSizes[newSize] = currentSizes[newSize];
          else newSizes[newSize] = 0;
        });
        updatedColors[color] = newSizes;
      });
      setFormData(prev => ({ ...prev, colorsAndSizes: updatedColors }));
    }
  };

  const handleAddColor = () => {
    if (formData.isFinishedProduct) {
      toast.error("Les produits finis n'ont pas de couleurs");
      return;
    }
    if (!newColor) {
      toast.error("Veuillez entrer une couleur");
      return;
    }
    if (formData.colorsAndSizes.hasOwnProperty(newColor)) {
      toast.error("Cette couleur existe déjà");
      return;
    }
    const initialSizes = {};
    selectedSizes.forEach(size => { initialSizes[size] = 0; });
    setFormData(prev => ({
      ...prev,
      colorsAndSizes: { ...prev.colorsAndSizes, [newColor]: initialSizes }
    }));
    setNewColor("");
    toast.success(`Couleur ${newColor} ajoutée`);
  };

  const handleQuantityChange = (colorName, size, value) => {
    setFormData(prev => ({
      ...prev,
      colorsAndSizes: {
        ...prev.colorsAndSizes,
        [colorName]: { ...prev.colorsAndSizes[colorName], [size]: Number(value) || 0 }
      }
    }));
  };

  const handleFinishedProductSizeChange = (size, value) => {
    setFormData(prev => ({
      ...prev,
      sizesOnly: { ...prev.sizesOnly, [size]: Number(value) || 0 }
    }));
  };

  const getSizeLabel = (size) => {
    if (adultSizes.includes(size)) return size;
    if (childSizes.includes(size)) return `${size} ans`;
    return size;
  };

  const handlePackQuantityChange = (colorName) => {
    const nbPacks = packValues[colorName];
    if (!nbPacks || nbPacks === "") {
      toast.error("Veuillez entrer le nombre de packs reçus");
      return;
    }
    const nbPacksNum = Number(nbPacks);
    if (isNaN(nbPacksNum) || nbPacksNum <= 0) {
      toast.error("Veuillez entrer un nombre valide supérieur à 0");
      return;
    }
    const hasPackDefined = formData.pack.some(qty => qty > 0);
    if (!hasPackDefined) {
      toast.error("Définissez d'abord la composition d'un pack");
      return;
    }
    setFormData(prev => {
      const updatedColorSizes = { ...prev.colorsAndSizes[colorName] };
      let totalPieces = 0;
      selectedSizes.forEach((size, index) => {
        const packQtyForSize = prev.pack[index] || 0;
        const newQuantity = nbPacksNum * packQtyForSize;
        updatedColorSizes[size] = newQuantity;
        totalPieces += newQuantity;
      });
      toast.success(`${nbPacksNum} pack${nbPacksNum > 1 ? 's' : ''} → ${totalPieces} pièces totales pour ${colorName}`, { autoClose: 2500 });
      return {
        ...prev,
        colorsAndSizes: { ...prev.colorsAndSizes, [colorName]: updatedColorSizes }
      };
    });
  };

  const handleFinishedProductPackQuantityChange = () => {
    const nbPacks = packValues.global || packValues.finished;
    if (!nbPacks || nbPacks === "") {
      toast.error("Veuillez entrer le nombre de packs reçus");
      return;
    }
    const nbPacksNum = Number(nbPacks);
    if (isNaN(nbPacksNum) || nbPacksNum <= 0) {
      toast.error("Veuillez entrer un nombre valide supérieur à 0");
      return;
    }
    const hasPackDefined = formData.pack.some(qty => qty > 0);
    if (!hasPackDefined) {
      toast.error("Définissez d'abord la composition d'un pack");
      return;
    }
    setFormData(prev => {
      const updatedSizesOnly = { ...prev.sizesOnly };
      let totalPieces = 0;
      selectedSizes.forEach((size, index) => {
        const packQtyForSize = prev.pack[index] || 0;
        const newQuantity = nbPacksNum * packQtyForSize;
        updatedSizesOnly[size] = newQuantity;
        totalPieces += newQuantity;
      });
      toast.success(`${nbPacksNum} pack${nbPacksNum > 1 ? 's' : ''} → ${totalPieces} pièces totales`, { autoClose: 2500 });
      return { ...prev, sizesOnly: updatedSizesOnly };
    });
  };

  const handlePackValueChange = (colorName, value) => {
    setPackValues(prev => ({ ...prev, [colorName]: value }));
  };

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    const category = categories.find(cat => String(cat._id) === String(categoryId));
    setFormData(prev => ({
      ...prev,
      categoryId,
      category: category?.title || "",
      subcategory: "",
      subcategoryId: "",
    }));
  };

  const generateProductId = (fournisseur, category, subcategory, title) => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formattedSupplier = slugifyProductIdPart(fournisseur);
    const formattedCategory = slugifyProductIdPart(category);
    const formattedSubcategory = slugifyProductIdPart(subcategory);
    const formattedTitle = slugifyProductIdPart(title);
    return `${formattedSupplier}_${formattedCategory}_${formattedSubcategory}_${formattedTitle}_${day}${month}${year}`;
  };

  const handleGenerateId = () => {
    if (!formData.fournisseur) { toast.error("Remplir Fournisseur !!"); return; }
    if (!formData.category) { toast.error("Remplir Catégorie !!"); return; }
    if (!formData.subcategory) { toast.error("Remplir Sous-catégorie !!"); return; }
    if (!formData.title) { toast.error("Remplir le nom du produit !!"); return; }
    if (selectedSizeTypes.length === 0) { toast.error("Sélectionnez au moins un type de taille (Adultes/Enfants)"); return; }
    const generatedId = generateProductId(formData.fournisseur, formData.category, formData.subcategory, formData.title);
    setFormData(prev => ({ ...prev, _id: generatedId }));
  };

  const calculateTotalQuantity = () => {
    if (formData.isFinishedProduct) {
      let total = 0;
      Object.values(formData.sizesOnly).forEach(qty => total += Number(qty) || 0);
      return total;
    } else {
      let total = 0;
      Object.values(formData.colorsAndSizes).forEach(colorSizes => {
        Object.values(colorSizes).forEach(qty => total += Number(qty) || 0);
      });
      return total;
    }
  };

  const getTotalCost = () => (parseFloat(formData.purchase) || 0) + (parseFloat(formData.cost) || 0);
  const getPriceAfterDiscount = () => {
    const price = parseFloat(formData.price) || 0;
    const discount = parseFloat(formData.discount) || 0;
    return discount > 0 ? price * (1 - discount / 100) : price;
  };

  const formatFileSize = (size) => size < 1024 * 1024 ? `${Math.max(1, Math.round(size / 1024))} KB` : `${(size / (1024 * 1024)).toFixed(1)} MB`;
  const formatPreorderDate = (value) => {
    if (!value) return "";
    const [year, month, day] = String(value).split("-");
    if (!year || !month || !day) return "";
    return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const handleSubmit = async () => {
    if (!formData._id) { toast.error('Veuillez générer un ID pour le produit'); return; }
    if (!formData.fournisseur) { toast.error('Veuillez renseigner le fournisseur'); return; }
    if (!formData.categoryId && !formData.category) { toast.error('Veuillez sélectionner une catégorie'); return; }
    if (!formData.subcategory) { toast.error('Veuillez sélectionner une sous-catégorie'); return; }
    if (!frontImageFile || !backImageFile) { toast.error('Veuillez ajouter les images devant et dos'); return; }
    if (selectedSizes.length === 0) { toast.error('Veuillez sélectionner au moins une taille'); return; }
    if (formData.isPreorder && !formData.preorderAvailableAt) { toast.error('Veuillez choisir la date de disponibilite'); return; }
    setIsSubmitting(true);

    const formDataToSend = new FormData();
    formDataToSend.append('_id', formData._id);
    formDataToSend.append('fournisseur', formData.fournisseur);
    formDataToSend.append('categoryId', formData.categoryId || '');
    formDataToSend.append('category', formData.category);
    formDataToSend.append('subcategory', formData.subcategory);
    formDataToSend.append('subcategoryId', formData.subcategoryId || '');
    formDataToSend.append('title', formData.title || formData._id);
    formDataToSend.append('description', formData.description || '');
    formDataToSend.append('purchase', formData.purchase.toString());
    formDataToSend.append('cost', formData.cost.toString());
    formDataToSend.append('price', formData.price.toString());
    formDataToSend.append('discount', formData.discount.toString());
    formDataToSend.append('rate', formData.rate.toString());
    formDataToSend.append('tags', JSON.stringify(formData.tags));
    formDataToSend.append('patronnage', formData.patronnage || '');
    formDataToSend.append('fourniture', JSON.stringify(formData.fourniture));
    formDataToSend.append('pack', JSON.stringify(formData.pack));
    formDataToSend.append('isFinishedProduct', formData.isFinishedProduct.toString());
    formDataToSend.append('fabricRawMaterialId', formData.fabricRawMaterialId || '');
    formDataToSend.append('fabricConsumption', JSON.stringify(formData.fabricConsumption || {}));
    formDataToSend.append('isPublishedB2B', formData.isPublishedB2B.toString());
    formDataToSend.append('isPublishedAdmin', formData.isPublishedAdmin.toString());
    formDataToSend.append('isPreorder', formData.isPreorder.toString());
    formDataToSend.append('preorderAvailableAt', formData.isPreorder ? formData.preorderAvailableAt : '');

    if (formData.isFinishedProduct) {
      formDataToSend.append('sizesOnly', JSON.stringify(formData.sizesOnly));
      formDataToSend.append('colorsAndSizes', JSON.stringify({}));
    } else {
      formDataToSend.append('colorsAndSizes', JSON.stringify(formData.colorsAndSizes));
      formDataToSend.append('sizesOnly', JSON.stringify({}));
    }

    // Append images and their types
    const allImages = [];
    const imageTypes = [];

    // Front image
    if (frontImageFile) {
      allImages.push(frontImageFile);
      imageTypes.push('front');
    }
    // Back image
    if (backImageFile) {
      allImages.push(backImageFile);
      imageTypes.push('back');
    }
    // Gallery images
    galleryImages.forEach((img, idx) => {
      allImages.push(img.file);
      imageTypes.push(`gallery-${idx+1}`);
    });

    allImages.forEach(file => formDataToSend.append('images', file));
    formDataToSend.append('imageTypes', JSON.stringify(imageTypes));

    try {
      const res = await api.post("/products", formDataToSend, { headers: { 'Content-Type': 'multipart/form-data' } });
      clearFormFromLocalStorage();
      setHasUnsavedChanges(false);
      const newProductId = res.data?.product?._id;
      if (res.data?.stockPending && newProductId) {
        toast.success("Produit créé ! Ajoutez maintenant son stock.");
        setTimeout(() => navigate(`/stock?productId=${encodeURIComponent(newProductId)}`), 1500);
      } else {
        toast.success(formData.isFinishedProduct ? 'Produit fini ajouté avec succès!' : 'Produit ajouté avec succès!');
        setTimeout(() => navigate("/products"), 2000);
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error(err.response?.data?.error || 'Erreur lors de la sauvegarde');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-product-container">
      {showRestorePrompt && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999,
          display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)'
        }}>
          <div style={{ background: 'var(--surface)', borderRadius: '24px', padding: '2rem', maxWidth: '500px', width: '90%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', border: '1px solid var(--border)' }}>
            <h3 style={{ marginBottom: '1rem', color: 'var(--accent)' }}>📝 Formulaire non terminé</h3>
            <p style={{ marginBottom: '0.5rem', color: 'var(--text-secondary)' }}>Un formulaire de produit non terminé a été trouvé.</p>
            <p style={{ marginBottom: '1.5rem', color: 'var(--text-muted)', fontSize: '0.85rem' }}>⚠️ Les images devront être re-téléchargées après restauration.</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button onClick={restoreSavedForm} style={{ background: 'var(--accent)', color: 'white', padding: '0.75rem 1.5rem', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 600 }}>Restaurer</button>
              <button onClick={clearSavedForm} style={{ background: 'var(--danger)', color: 'white', padding: '0.75rem 1.5rem', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: 600 }}>Ignorer</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem', gap: '0.5rem' }}>
        {hasUnsavedChanges && <span style={{ fontSize: '0.75rem', color: 'var(--accent)', padding: '0.5rem 1rem', background: 'var(--accent-soft)', borderRadius: '8px' }}>💾 Modifications non sauvegardées</span>}
        <button onClick={resetForm} style={{ background: 'var(--danger)', color: 'white', padding: '0.5rem 1rem', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '0.8rem' }}>🗑️ Réinitialiser le formulaire</button>
      </div>

      <div className="add-product-grid">
        <div className="add-product-grid-item">
          <div className="form-group">
            <h4>Type de produit</h4>
            <div className="add-product-sizes-container">
              <label className={`add-product-sizes-label ${!formData.isFinishedProduct ? 'active' : ''}`}>
                <input type="radio" name="productType" checked={!formData.isFinishedProduct} onChange={() => handleFinishedProductToggle(false)} />
                Produit standard (avec couleurs)
              </label>
              <label className={`add-product-sizes-label ${formData.isFinishedProduct ? 'active' : ''}`}>
                <input type="radio" name="productType" checked={formData.isFinishedProduct} onChange={() => handleFinishedProductToggle(true)} />
                Produit fini (sans couleurs)
              </label>
            </div>
          </div>

          <div className="form-group preorder-fields">
            <h4>Statut B2B</h4>
            <div className="preorder-grid">
              <div>
                <select
                  className="add-product-input"
                  value={formData.isPreorder ? "preorder" : "standard"}
                  onChange={(e) => setFormData(prev => ({
                    ...prev,
                    isPreorder: e.target.value === "preorder",
                    preorderAvailableAt: e.target.value === "preorder" ? prev.preorderAvailableAt : "",
                  }))}
                >
                  <option value="standard">Catalogue standard</option>
                  <option value="preorder">Precommande</option>
                </select>
              </div>
              {formData.isPreorder && (
                <div>
                  <div className="add-product-input">
                    <input
                      type="date"
                      className="add-product-input-text"
                      value={formData.preorderAvailableAt}
                      min={new Date().toISOString().slice(0, 10)}
                      onChange={(e) => setFormData(prev => ({ ...prev, preorderAvailableAt: e.target.value }))}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="field-note">
              {formData.isPreorder
                ? `Visible dans la section precommandes${formData.preorderAvailableAt ? ` - disponible le ${formatPreorderDate(formData.preorderAvailableAt)}` : ""}`
                : "Visible dans la boutique normale"}
            </div>
          </div>

          <div className="form-group">
            <h4>Images du produit</h4>
            <div style={{ marginBottom: '1rem' }}>
              <h4 style={{ fontSize: '0.8rem', marginBottom: '0.5rem' }}>Image devant (obligatoire)</h4>
              <div className="add-product-input"><input type="file" accept="image/*" onChange={(e) => handleImageUpload('front', e.target.files[0])} /></div>
              {imagePreviews.front && <div className="field-note" style={{ color: 'var(--success)' }}>✅ Image devant chargée</div>}
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <h4 style={{ fontSize: '0.8rem', marginBottom: '0.5rem' }}>Image dos (obligatoire)</h4>
              <div className="add-product-input"><input type="file" accept="image/*" onChange={(e) => handleImageUpload('back', e.target.files[0])} /></div>
              {imagePreviews.back && <div className="field-note" style={{ color: 'var(--success)' }}>✅ Image dos chargée</div>}
            </div>

            {/* Gallery images section (like AddDesign) */}
            <div className="design-gallery-section" style={{ marginTop: '1rem' }}>
              <div className="design-gallery-header">
                <div>
                  <h4>Images additionnelles (galerie) â€“ {galleryImages.length} image(s)</h4>
                  <div className="field-note">Ajoutez plusieurs images pour la galerie du produit (facultatif). Elles seront sauvegardées sur OVH.</div>
                </div>
                <span className="design-gallery-pill">OVH</span>
              </div>
              <div className="add-product-input"><input type="file" accept="image/*" onChange={handleGalleryImageUpload} multiple /></div>
              {galleryImages.length > 0 && (
                <div className="design-gallery-grid">
                  {galleryImages.map((image, idx) => (
                    <div className="design-gallery-card" key={image.id}>
                      <img src={image.previewUrl} alt={image.name} />
                      <button type="button" className="design-gallery-remove" onClick={() => handleDeleteGalleryImage(image.id)} title="Supprimer l'image"><UilTrashAlt size={16} /></button>
                      <div className="design-gallery-meta">
                        <span>{idx+1}. {image.name}</span>
                        <small>{formatFileSize(image.size)}</small>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="form-group">
            <h4>Titre du produit</h4>
            <div className="add-product-input"><input onChange={(e) => setFormData({ ...formData, title: e.target.value })} className="add-product-input-text" placeholder="Titre du produit" value={formData.title} /></div>
          </div>

          <div className="form-group">
            <h4>Description</h4>
            <div className="add-product-input"><textarea onChange={(e) => setFormData({ ...formData, description: e.target.value })} className="add-product-input-paragraph" placeholder="Description du produit" value={formData.description} /></div>
          </div>

          <div className="add-product-price">
            <div><h4>Fournisseur</h4><div className="add-product-input"><input type="text" onChange={(e) => setFormData(prev => ({ ...prev, fournisseur: e.target.value }))} className="add-product-input-text" placeholder="Nom du fournisseur" value={formData.fournisseur} /></div></div>
            <div><h4>Prix d'achat (HT)</h4><div className="add-product-input"><input type="number" onChange={(e) => setFormData({ ...formData, purchase: Number(e.target.value) })} className="add-product-input-text" placeholder="Prix d'achat (€)" value={formData.purchase} /></div></div>
          </div>

          {formData.isFinishedProduct && (
            <>
              <div className="add-product-price finished-product-price">
                <div><h4>Coût de production</h4><div className="add-product-input"><input type="number" className="add-product-input-text" placeholder="Ex: 5.00" onChange={(e) => setFormData(prev => ({ ...prev, cost: Number(e.target.value) }))} value={formData.cost} min="0" step="0.01" /></div><div className="field-note">Coût de personnalisation / finition du produit</div></div>
                <div><h4>Coût total (revient)</h4><div className="add-product-input" style={{ background: "var(--accent-soft)" }}><input readOnly type="text" className="add-product-input-text" value={getTotalCost().toFixed(2)} style={{ fontWeight: "600", color: "var(--accent)" }} /></div><div className="field-note">= Prix d'achat + Coût de production</div></div>
                <div><h4>Prix de vente</h4><div className="add-product-input"><input onChange={(e) => setFormData(prev => ({ ...prev, price: Number(e.target.value) }))} type="number" className="add-product-input-text" placeholder="Ex: 29.99" value={formData.price} min="0" step="0.01" /></div><div className="field-note">Prix final pour le client</div></div>
                <div><h4>Promotion (%)</h4><div className="add-product-input"><input onChange={(e) => setFormData(prev => ({ ...prev, discount: Number(e.target.value) }))} type="number" className="add-product-input-text" placeholder="0" value={formData.discount} min="0" max="100" /></div>{formData.discount > 0 && <div className="field-note" style={{ color: 'var(--success)' }}>Prix après promotion: €{getPriceAfterDiscount().toFixed(2)}</div>}</div>
              </div>
            </>
          )}

          <div className="add-product-categories">
            <div><h4>Catégorie</h4><select className="add-product-input" value={formData.categoryId || ""} onChange={handleCategoryChange}><option value="">Sélectionner catégorie</option>{categories?.map((cat) => (<option key={cat._id} value={cat._id}>{cat.title}</option>))}</select></div>
            <div><h4>Sous-catégorie</h4><select onChange={(e) => {
              const selected = subcategories.find(sub => String(sub._id) === e.target.value);
              setFormData({ ...formData, subcategoryId: selected?._id || "", subcategory: selected?.title || "" });
            }} className="add-product-input" value={formData.subcategoryId}><option value="">Sélectionner sous-catégorie</option>{subcategories?.map((sub) => (<option key={sub._id} value={sub._id}>{sub.title}</option>))}</select></div>
          </div>

          {!formData.isFinishedProduct && (
            <div className="form-group">
              <h4>Couleurs</h4>
              <div className="add-product-colors">
                {Object.entries(formData.colorsAndSizes).map(([colorName, sizes], index) => (
                  <div key={index} className="choose-color" style={{ backgroundColor: colorName }} onClick={() => setDisplayedColor(colorName)} title={colorName}>
                    <button type="button" onClick={(e) => { e.stopPropagation(); const updatedColors = { ...formData.colorsAndSizes }; delete updatedColors[colorName]; setFormData({ ...formData, colorsAndSizes: updatedColors }); if (displayedColor === colorName) setDisplayedColor(""); toast.info(`Couleur ${colorName} supprimée`); }}>&times;</button>
                  </div>
                ))}
              </div>
              <div className="add-product-colors-input">
                <input type="text" placeholder="Ajouter une couleur (ex: red, #FF0000, rgb(255,0,0))" value={newColor} onChange={(e) => setNewColor(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAddColor(); } }} />
                <button type="button" onClick={handleAddColor}>Ajouter</button>
              </div>
            </div>
          )}

          <div className="form-group">
            <h4>Types de tailles (sélection multiple)</h4>
            <div className="add-product-sizes-container">
              <label className={`add-product-sizes-label ${selectedSizeTypes.includes('adult') ? 'active' : ''}`}><input type="checkbox" checked={selectedSizeTypes.includes('adult')} onChange={() => handleSizeTypeToggle('adult')} /> Adultes (XS à XXL)</label>
              <label className={`add-product-sizes-label ${selectedSizeTypes.includes('child') ? 'active' : ''}`}><input type="checkbox" checked={selectedSizeTypes.includes('child')} onChange={() => handleSizeTypeToggle('child')} /> Enfants (4 à 16 ans)</label>
            </div>
            {selectedSizeTypes.length === 0 && <div className="field-note" style={{ color: 'var(--danger)' }}>⚠️ Sélectionnez au moins un type de taille</div>}
          </div>

          {selectedSizeTypes.length > 0 && (
            <div className="form-group">
              <h4>Tailles disponibles</h4>
              <div className="add-product-sizes-container">
                {getAllAvailableSizes().map((sizeInfo) => (
                  <label key={`${sizeInfo.type}_${sizeInfo.value}`} className="add-product-sizes-label">
                    <input type="checkbox" value={sizeInfo.value} checked={selectedSizes.includes(sizeInfo.value)} onChange={() => handleSizeChange(sizeInfo.value)} />
                    {sizeInfo.label}
                  </label>
                ))}
              </div>
              {selectedSizes.length > 0 && (<div className="field-note">✅ {selectedSizes.length} taille(s) sélectionnée(s)<br/><span style={{ fontSize: '0.7rem' }}>Adultes: {selectedSizes.filter(s => adultSizes.includes(s)).length} | Enfants: {selectedSizes.filter(s => childSizes.includes(s)).length}</span></div>)}
            </div>
          )}

          {selectedSizes.length > 0 && (
            <div className="quantity-container">
              <div className="pack-quantity-row">
                <h4>Composition d'un pack</h4>
                <div className="pack-inputs">
                  {selectedSizes.map((size, index) => (
                    <div className={`pack-input-item ${(formData.pack[index] || 0) > 0 ? 'has-value' : ''}`} key={size}>
                      <h4>{getSizeLabel(size)}:</h4>
                      <input className="size-quantity" type="number" value={formData.pack[index] || 0} onChange={(e) => handlePackChange(index, e.target.value)} min={0} placeholder="0" />
                    </div>
                  ))}
                </div>
                <p className="helper-text">Nombre de pièces par taille dans un pack</p>
              </div>

              {!formData.isFinishedProduct ? (
                <>
                  {Object.entries(formData.colorsAndSizes).length > 0 ? (
                    <div className="add-product-colors-quantity">
                      {Object.entries(formData.colorsAndSizes).map(([colorName, sizes]) => {
                        const hasQuantities = Object.values(sizes).some(qty => qty > 0);
                        const totalForColor = Object.values(sizes).reduce((sum, qty) => sum + (Number(qty) || 0), 0);
                        return (
                          <div className={`color-quantity-card ${hasQuantities ? 'has-stock' : ''}`} key={colorName}>
                            <div className="color-quantity-header">
                              <div className="choose-color" style={{ backgroundColor: colorName }} onClick={() => setDisplayedColor(colorName)} />
                              <h4 style={{ margin: 0 }}>{colorName}</h4>
                              {hasQuantities && <span className="stock-badge">Stock: {totalForColor} pièces</span>}
                            </div>
                            <div className="color-quantity-sizes">
                              {selectedSizes.map((size) => (
                                <div className="size-quantity-item" key={size}>
                                  <h4>{getSizeLabel(size)}</h4>
                                  <input className="size-quantity" type="number" value={formData.colorsAndSizes[colorName]?.[size] ?? 0} min={0} onChange={(e) => handleQuantityChange(colorName, size, e.target.value)} />
                                </div>
                              ))}
                            </div>
                            <div className="pack-calculator">
                              <h4>Nombre de packs reçus</h4>
                              <input className="size-quantity" type="number" min={0} step={1} value={packValues[colorName] || ""} onChange={(e) => handlePackValueChange(colorName, e.target.value)} placeholder="ex: 5" />
                              <button onClick={() => handlePackQuantityChange(colorName)}><UilCalculator size={16} /><span>Calculer</span></button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (<h4 style={{ color: "#dc3545", textAlign: "center", marginTop: "1rem" }}>Veuillez ajouter des couleurs</h4>)}
                </>
              ) : (
                <div className="add-product-colors-quantity">
                  <div className="color-quantity-card">
                    <div className="color-quantity-header"><h4 style={{ margin: 0 }}>Quantités par taille</h4></div>
                    <div className="color-quantity-sizes">
                      {selectedSizes.map((size) => (
                        <div className="size-quantity-item" key={size}>
                          <h4>{getSizeLabel(size)}</h4>
                          <input className="size-quantity" type="number" value={formData.sizesOnly[size] ?? 0} min={0} onChange={(e) => handleFinishedProductSizeChange(size, e.target.value)} />
                        </div>
                      ))}
                    </div>
                    <div className="pack-calculator">
                      <h4>Nombre de packs reçus</h4>
                      <input className="size-quantity" type="number" min={0} step={1} value={packValues.global || packValues.finished || ""} onChange={(e) => handlePackValueChange('global', e.target.value)} placeholder="ex: 5" />
                      <button onClick={handleFinishedProductPackQuantityChange}><UilCalculator size={16} /><span>Calculer</span></button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          <div className="form-group">
            <h4>Tags</h4>
            <div className="add-product-tags">
              {formData.tags.map((tag, index) => (<span key={index}>{tag}<button type="button" onClick={() => { const updated = formData.tags.filter((_, i) => i !== index); setFormData({ ...formData, tags: updated }); }}>&times;</button></span>))}
            </div>
            <div className="add-product-tags-input">
              <input type="text" placeholder="Ajouter un tag" value={tagInput} onChange={(e) => setTagInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAddTag(); } }} />
              <button type="button" onClick={handleAddTag}>Ajouter</button>
            </div>
          </div>

          <div className="form-group">
            <h4>Patronnage</h4>
            <input
              type="text"
              placeholder="Référence du patronnage"
              value={formData.patronnage}
              onChange={(e) => setFormData({ ...formData, patronnage: e.target.value })}
            />
          </div>

          <div className="form-group">
            <h4>Fourniture</h4>
            <div className="add-product-tags">
              {formData.fourniture.map((item, index) => (<span key={index}>{item}<button type="button" onClick={() => { const updated = formData.fourniture.filter((_, i) => i !== index); setFormData({ ...formData, fourniture: updated }); }}>&times;</button></span>))}
            </div>
            <div className="add-product-tags-input">
              <input type="text" placeholder="Ajouter une fourniture" value={fournitureInput} onChange={(e) => setFournitureInput(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAddFourniture(); } }} />
              <button type="button" onClick={handleAddFourniture}>Ajouter</button>
            </div>
          </div>

          <div className="form-group">
            <h4>Consommation matière (kg de tissu)</h4>
            <select
              className="add-product-input"
              value={formData.fabricRawMaterialId}
              onChange={(e) => setFormData({ ...formData, fabricRawMaterialId: e.target.value })}
            >
              <option value="">Sélectionner une matière première...</option>
              {rawMaterials.map((rm) => (
                <option key={rm._id} value={rm._id}>{rm.name} ({rm.unit})</option>
              ))}
            </select>
            {selectedSizes.length > 0 ? (
              <div className="quantity-container" style={{ marginTop: '0.75rem' }}>
                {selectedSizes.map((size) => (
                  <div key={size} className="size-quantity-item">
                    <h4>{getSizeLabel(size)}</h4>
                    <div className="fabric-qty-input">
                      <input
                        className="size-quantity"
                        type="number"
                        min={0}
                        step={0.01}
                        placeholder="0"
                        value={formData.fabricConsumption[size] ?? ""}
                        onChange={(e) => setFormData({
                          ...formData,
                          fabricConsumption: { ...formData.fabricConsumption, [size]: e.target.value },
                        })}
                      />
                      <span className="fabric-qty-unit">KG</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="field-note">Sélectionnez d'abord des tailles pour renseigner la consommation.</div>
            )}
          </div>

          {formData.isFinishedProduct && (
            <div className="form-group">
              <h4>Publication</h4>
              <div className="add-product-colors-input">
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, isPublishedB2B: !formData.isPublishedB2B })}
                  style={{ background: formData.isPublishedB2B ? 'var(--success, #22c55e)' : undefined }}
                >
                  {formData.isPublishedB2B ? '✔ Publié dans B2B' : 'Publier dans B2B'}
                </button>
                <button
                  type="button"
                  onClick={() => setFormData({ ...formData, isPublishedAdmin: !formData.isPublishedAdmin })}
                  style={{ background: formData.isPublishedAdmin ? 'var(--success, #22c55e)' : undefined }}
                >
                  {formData.isPublishedAdmin ? '✔ Publié dans Admin' : 'Publier dans Admin'}
                </button>
              </div>
              <div className="field-note">
                Publié dans B2B = visible dans la boutique client. Publié dans Admin = sélectionnable dans "Nv Commande" par le staff.
              </div>
            </div>
          )}

          <div className="form-group">
            <h4>Référence du produit</h4>
            <div className="add-product-colors-input id-generation-row">
              <input type="text" placeholder="ID du produit" value={formData._id || ''} readOnly />
              <button type="button" onClick={handleGenerateId}>Générer ID</button>
            </div>
          </div>

          {selectedSizes.length > 0 && (
            <div className="quantity-container" style={{ marginTop: '1rem', background: 'var(--accent-soft)' }}>
              <h4>Résumé du produit</h4>
              <div className="field-note">👕 Types: {selectedSizeTypes.map(t => t === 'adult' ? 'Adultes' : 'Enfants').join(' + ')}</div>
              <div className="field-note">📏 Tailles: {selectedSizes.map(s => getSizeLabel(s)).join(', ')}</div>
              {!formData.isFinishedProduct ? (
                <>
                  <div className="field-note">🎨 Couleurs: {Object.keys(formData.colorsAndSizes).length > 0 ? Object.keys(formData.colorsAndSizes).join(', ') : 'Aucune'}</div>
                  <div className="field-note">📊 Stock total: {calculateTotalQuantity()} pièces</div>
                </>
              ) : (
                <>
                  <div className="field-note">📊 Stock total: {calculateTotalQuantity()} pièces</div>
                  <div className="field-note">🏷️ Produit fini - vente directe</div>
                </>
              )}
              <div className="field-note">🖼️ Images: {frontImageFile ? '✔️ devant' : '❌ devant'} | {backImageFile ? '✔️ dos' : '❌ dos'} | {galleryImages.length} galerie</div>
              {formData.isPreorder && (
                <div className="field-note">Precommande: disponible le {formatPreorderDate(formData.preorderAvailableAt) || "date a choisir"}</div>
              )}
            </div>
          )}

          <div className="category-publish-buttons">
            <button onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? 'Envoi en cours...' : (formData.isFinishedProduct ? 'Ajouter le produit fini' : 'Sauvegarder le produit')}</button>
          </div>
        </div>

        <div className="add-product-grid-item">
          <div className="images-preview-section">
            <h3>Image devant (aperçu)</h3>
            {imagePreviews.front ? (
              <div className="preview-image-card">
                {formData.isFinishedProduct ? (
                  <img src={imagePreviews.front} alt="Apercu devant" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                ) : (
                  <ColorPreviewCanvas ref={frontCanvasRef} imageUrl={imagePreviews.front} color={displayedColor} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                )}
              </div>
            ) : (<div className="no-images-placeholder"><p>Aucune image devant sélectionnée</p></div>)}
          </div>
          <div className="images-preview-section">
            <h3>Image dos (aperçu)</h3>
            {imagePreviews.back ? (
              <div className="preview-image-card">
                {formData.isFinishedProduct ? (
                  <img src={imagePreviews.back} alt="Apercu dos" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                ) : (
                  <ColorPreviewCanvas ref={backCanvasRef} imageUrl={imagePreviews.back} color={displayedColor} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                )}
              </div>
            ) : (<div className="no-images-placeholder"><p>Aucune image dos sélectionnée</p></div>)}
          </div>
          {galleryImages.length > 0 && (
            <div className="images-preview-section" style={{ marginTop: '1rem' }}>
              <h3>Galerie ({galleryImages.length})</h3>
              <div className="preview-image-card" style={{ aspectRatio: 'auto', minHeight: '150px', overflowY: 'auto' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))', gap: '8px' }}>
                  {galleryImages.map((img) => (
                    <img key={img.id} src={img.previewUrl} alt={img.name} style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', borderRadius: '8px' }} />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ToastContainer position="top-right" />
    </div>
  );
};
